import { render, staticRenderFns } from "./PageClaimsList.vue?vue&type=template&id=6aaa3b9e&scoped=true"
import script from "./PageClaimsList.vue?vue&type=script&lang=ts"
export * from "./PageClaimsList.vue?vue&type=script&lang=ts"
import style0 from "./PageClaimsList.vue?vue&type=style&index=0&id=6aaa3b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa3b9e",
  null
  
)

export default component.exports